import React, { createContext, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import APIServices from './services/APIServices';
import apiconfig from './config/config';
import { setEnvironmentSelected } from './Redux/Actions';
export const EnvironmentContext = createContext();

export const EnvironmentProvider = ({ children }) => {
    const dispatch = useDispatch();
    const environmentSelected = useSelector((state) => state.environmentSelected);
    const [environment, setEnvironmentState] = useState(environmentSelected || "Production");
    useEffect(() => {
        const url = environment === "Production"
            ? apiconfig.production.apiBaseUrl
            : apiconfig.develpoment.apiBaseUrl;
        APIServices.setApiBaseUrl(url);
        console.log(`Setting API base URL to: ${url}`);
    }, [environment]);

    const setEnvironment = (newEnvironment) => {
        setEnvironmentState(newEnvironment);
        dispatch(setEnvironmentSelected(newEnvironment));

    };

    return (
        <EnvironmentContext.Provider value={{ environment, setEnvironment }}>
            {children}
        </EnvironmentContext.Provider>
    );
};

